"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/ban-types */
var react_1 = require("react");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
var assert_1 = require("tsafe/assert");
function isMuiIcon(Component) {
    return "type" in Component;
}
function createIcon(componentByIconId) {
    var useStyles = ThemeProvider_1.makeStyles()(function (theme, _a) {
        var size = _a.size;
        return ({
            "root": {
                "color": "inherit",
                // https://stackoverflow.com/a/24626986/3731798
                //"verticalAlign": "top",
                //"display": "inline-block"
                "verticalAlign": "top",
                "fontSize": theme.iconSizesInPxByName[size],
                "width": "1em",
                "height": "1em",
            },
        });
    });
    var Icon = react_1.memo(react_1.forwardRef(function (props, ref) {
        var iconId = props.iconId, className = props.className, _a = props.size, size = _a === void 0 ? "default" : _a, onClick = props.onClick, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        children = props.children, rest = __rest(props, ["iconId", "className", "size", "onClick", "children"]);
        //For the forwarding, rest should be empty (typewise),
        assert_1.assert();
        var _b = useStyles({ size: size }), classes = _b.classes, cx = _b.cx;
        var Component = componentByIconId[iconId];
        return isMuiIcon(Component) ? (jsx_runtime_1.jsx(Component, __assign({ ref: ref, className: cx(classes.root, className), onClick: onClick }, rest), void 0)) : (jsx_runtime_1.jsx(SvgIcon_1.default, __assign({ ref: ref, onClick: onClick, className: cx(classes.root, className), component: Component }, rest), void 0));
    }));
    return { Icon: Icon };
}
exports.createIcon = createIcon;
//# sourceMappingURL=Icon.js.map